module.exports = __webpack_public_path__ + "img/Z86Q_05.813dac48.jpg";